import { Injectable } from '@angular/core';
import { PersonalInfoTitleConfig } from '../interface/personal-info-title.interface';


@Injectable()
export class PersonalInfoTitleConfigService {
    constructor(
    ) { }

    /**
        * @description this method will get the config settings for combo packs page
        * @date 2019-09-16
        * @memberof CartSummaryDetailConfigSettings
        */
     public getSettings(countryCode: string): PersonalInfoTitleConfig {
        let personalInfoTitleConfig: PersonalInfoTitleConfig;
        switch (countryCode.toUpperCase()) {
            case 'BEL':
                personalInfoTitleConfig = this.loadBELSettings();
                break;
            case 'LUX':
                personalInfoTitleConfig = this.loadLUXSettings();
                break;
            case 'NLD':
                personalInfoTitleConfig = this.loadNLDSettings();
                break;
            case 'DEU':
                personalInfoTitleConfig = this.loadDEUSettting();
                break;
            case 'AUT':
                personalInfoTitleConfig = this.loadAUTSettting();
                break;
            case 'CHE':
                personalInfoTitleConfig = this.loadCHESettting();
                break;
           
            default:
                personalInfoTitleConfig = this.loadGBRSettings();
                break;
        }
        return personalInfoTitleConfig;
    }
  
    /**
     * @description this method will return BEL settings
     * @date 2021-04-05
     * @private
     * @returns {OrderSummaryConfig}
     * @memberof OrderSummaryConfigService
     */
     private loadBELSettings(): PersonalInfoTitleConfig {
        const personalInfoTitleConfig: PersonalInfoTitleConfig = {
            countryCode: 'BEL',
            useContactTypeAsPhone : true,
            personalInfoTitleType:[{ titlename:"Mr",titlevalue:"126" },
                                  { titlename:"Mrs",titlevalue:"127" },
                                  { titlename:"Other",titlevalue:"147" },
                                  { titlename:"I do not want to disclose",titlevalue:"148" }
                                ]        
        };
        return personalInfoTitleConfig;
    }
    
     /**
     * @description this method will return LUX settings
     * @date 2021-04-05
     * @private
     * @returns {OrderSummaryConfig}
     * @memberof OrderSummaryConfigService
     */
      private loadNLDSettings(): PersonalInfoTitleConfig {
        const personalInfoTitleConfig: PersonalInfoTitleConfig = {
            countryCode: 'NLD',
            useContactTypeAsPhone : true,
            personalInfoTitleType:[{ titlename:"Mr",titlevalue:"126" },
                                   { titlename:"Mrs",titlevalue:"127" },
                                  { titlename:"Other",titlevalue:"147" },
                                  { titlename:"I do not want to disclose",titlevalue:"148" }]        
        };
        return personalInfoTitleConfig;
    }
     /**
     * @description this method will return NLD settings
     * @date 2021-04-05
     * @private
     * @returns {OrderSummaryConfig}
     * @memberof OrderSummaryConfigService
     */
      private loadLUXSettings(): PersonalInfoTitleConfig {
        const personalInfoTitleConfig: PersonalInfoTitleConfig = {
            countryCode: 'LUX',
            useContactTypeAsPhone : true,
            personalInfoTitleType:[{ titlename:"Mr",titlevalue:"126" },
                                  { titlename:"Mrs",titlevalue:"127" },
                                  { titlename:"Other",titlevalue:"147" },
                                  { titlename:"I do not want to disclose",titlevalue:"148" }]        
        };
        return personalInfoTitleConfig;
    }

      
     /**
     * @description this method will return NZL settings
     * @date 2021-04-05
     * @private
     * @returns {OrderSummaryConfig}
     * @memberof OrderSummaryConfigService
     */
      private loadGBRSettings(): PersonalInfoTitleConfig {
        const personalInfoTitleConfig: PersonalInfoTitleConfig = {
            countryCode: 'GBR',
            useContactTypeAsPhone : false,
            personalInfoTitleType:[{ titlename:"Mr",titlevalue:"126" },
                                  { titlename:"Mrs",titlevalue:"127" },
                                  { titlename:"Ms",titlevalue:"128" }]        
        };
        return personalInfoTitleConfig;
    }

    /**
     * @description this method will return AUT settings
     * @date 2022-09-05
     * @private
     * @returns {OrderSummaryConfig}
     * @memberof OrderSummaryConfigService
     */
    
      private loadAUTSettting(): PersonalInfoTitleConfig {
        const personalInfoTitleConfig: PersonalInfoTitleConfig = {
            countryCode: 'AUT',
            useContactTypeAsPhone: false,
            personalInfoTitleType: [{ titlename: "Mr", titlevalue: "126" },
            { titlename: "Ms/Mrs", titlevalue: "230" },
            { titlename: "Unknown", titlevalue: "231" },
            { titlename: "Mr Dr.", titlevalue: "232" },
            { titlename: "Mr Mag.", titlevalue: "233" },
            { titlename: "Mr Prof.", titlevalue: "234" },
            { titlename: "Mr Ing.", titlevalue: "235" },
            { titlename: "Mr Dr. med. vet.", titlevalue: "236" },
            { titlename: "Mr Dipl.-Ing.", titlevalue: "237" },
            { titlename: "Mr Dr. med.", titlevalue: "238" },
            { titlename: "Mr Dipl.-Psych.", titlevalue: "239" },
            { titlename: "Mr Prof. Dr.", titlevalue: "240" },
            { titlename: "Ms/Mrs Dr.", titlevalue: "241" },
            { titlename: "Ms/Mrs Mag.", titlevalue: "242" },
            { titlename: "Ms/Mrs Prof.", titlevalue: "243" },
            { titlename: "Ms/Mrs Ing.", titlevalue: "244" },
            { titlename: "Ms/Mrs Dr. med. vet.", titlevalue: "245" },
            { titlename: "Ms/Mrs Dipl.-Ing.", titlevalue: "246" },
            { titlename: "Ms/Mrs Dr. med.", titlevalue: "247" },
            { titlename: "Ms/Mrs Dipl.-Psych.", titlevalue: "248" },
            { titlename: "Ms/Mrs Prof. Dr.", titlevalue: "249" },
            { titlename: "Dr.", titlevalue: "250" },
            { titlename: "Mag.", titlevalue: "251" },
            { titlename: "Prof.", titlevalue: "252" },
            { titlename: "Ing.", titlevalue: "253" },
            { titlename: "Dr. med. vet.", titlevalue: "254" },
            { titlename: "Dipl.-Ing.", titlevalue: "255" },
            { titlename: "Mag. Dr.", titlevalue: "256" },
            { titlename: "Dr. med.", titlevalue: "257" },
            { titlename: "Dipl.-Psych.", titlevalue: "258" },
            { titlename: "Prof. Dr.", titlevalue: "259" },
            ]
        };
        return personalInfoTitleConfig;
    } 

     /**
     * @description this method will return DEU settings
     * @date 2022-09-05
     * @private
     * @returns {OrderSummaryConfig}
     * @memberof OrderSummaryConfigService
     */
    private loadDEUSettting(): PersonalInfoTitleConfig {
        const personalInfoTitleConfig: PersonalInfoTitleConfig = {
            countryCode: 'DEU',
            useContactTypeAsPhone: false,
            personalInfoTitleType: [{ titlename: "Mr", titlevalue: "126" },
            { titlename: "Ms/Mrs", titlevalue: "230" },
            { titlename: "Unknown", titlevalue: "231" },
            { titlename: "Mr Dr.", titlevalue: "232" },
            { titlename: "Mr Mag.", titlevalue: "233" },
            { titlename: "Mr Prof.", titlevalue: "234" },
            { titlename: "Mr Ing.", titlevalue: "235" },
            { titlename: "Mr Dr. med. vet.", titlevalue: "236" },
            { titlename: "Mr Dipl.-Ing.", titlevalue: "237" },
            { titlename: "Mr Dr. med.", titlevalue: "238" },
            { titlename: "Mr Dipl.-Psych.", titlevalue: "239" },
            { titlename: "Mr Prof. Dr.", titlevalue: "240" },
            { titlename: "Ms/Mrs Dr.", titlevalue: "241" },
            { titlename: "Ms/Mrs Mag.", titlevalue: "242" },
            { titlename: "Ms/Mrs Prof.", titlevalue: "243" },
            { titlename: "Ms/Mrs Ing.", titlevalue: "244" },
            { titlename: "Ms/Mrs Dr. med. vet.", titlevalue: "245" },
            { titlename: "Ms/Mrs Dipl.-Ing.", titlevalue: "246" },
            { titlename: "Ms/Mrs Dr. med.", titlevalue: "247" },
            { titlename: "Ms/Mrs Dipl.-Psych.", titlevalue: "248" },
            { titlename: "Ms/Mrs Prof. Dr.", titlevalue: "249" },
            { titlename: "Dr.", titlevalue: "250" },
            { titlename: "Mag.", titlevalue: "251" },
            { titlename: "Prof.", titlevalue: "252" },
            { titlename: "Ing.", titlevalue: "253" },
            { titlename: "Dr. med. vet.", titlevalue: "254" },
            { titlename: "Dipl.-Ing.", titlevalue: "255" },
            { titlename: "Mag. Dr.", titlevalue: "256" },
            { titlename: "Dr. med.", titlevalue: "257" },
            { titlename: "Dipl.-Psych.", titlevalue: "258" },
            { titlename: "Prof. Dr.", titlevalue: "259" },
            ]
        };
        return personalInfoTitleConfig;
    } 
    private loadCHESettting(): PersonalInfoTitleConfig {
        const personalInfoTitleConfig: PersonalInfoTitleConfig = {
            countryCode: 'CHE',
            useContactTypeAsPhone: false,
            personalInfoTitleType: [{ titlename: "Mr", titlevalue: "126" },
            { titlename:"Mrs",titlevalue:"127" }]
        };
        return personalInfoTitleConfig;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/persoanl-info-title-config.service.ts